import React, { createContext, useContext } from 'react';
import ptTranslations from './locales/pt.json';
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';

const translations = {
  pt: ptTranslations,
  en: enTranslations,
  es: esTranslations
};

const LanguageContext = createContext();

export const getLanguage = () => {
  return process.env.REACT_APP_LANGUAGE || 'pt';
};

export const LanguageProvider = ({ children }) => {
  const language = getLanguage();
  const currentTranslations = translations[language] || translations.pt;

  const t = (key, params = {}) => {
    const keys = key.split('.');
    let value = currentTranslations;

    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        console.warn(`Translation key not found: ${key}`);
        return key;
      }
    }

    if (typeof value === 'string') {
      return value.replace(/\{(\w+)\}/g, (match, param) => {
        return params[param] !== undefined ? params[param] : match;
      });
    }

    return value;
  };

  return (
    <LanguageContext.Provider value={{ language, t, translations: currentTranslations }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageProvider;
